import React from 'react';
import { useAuth } from 'react-oidc-context';
import { Header } from '@uhg-abyss/web/ui/Header';
import { Badge } from '@uhg-abyss/web/ui/Badge';

export const AppHeader: React.FC = () => {
  const auth = useAuth();
  const userName = auth.user?.profile?.name || auth.user?.profile?.preferred_username || '';

  const handleLogout = () => {
    auth.signoutRedirect();
  };

  return (
    <Header.Container>
      <Header.Brandmark logoRedirect="/" />
      <Header.MainContent>
        <span style={{ fontSize: 22, fontWeight: 600, whiteSpace: 'nowrap' }}>HPS Data Load Tools</span>
        <span style={{ fontSize: 13, opacity: 0.8, marginLeft: 16, textAlign: 'right', whiteSpace: 'nowrap' }}>
          Validate &amp; Map Data Load Files for Claim Status &amp; Eligibility
        </span>
      </Header.MainContent>
      <Header.Actions>
        {userName && (
          <span style={{ fontSize: 14, color: '#002677', fontWeight: 500, marginRight: 12 }}>
            {userName}
          </span>
        )}
        <Badge variant="neutral">v1.0.0</Badge>
        <button
          onClick={handleLogout}
          style={{
            marginLeft: 12,
            padding: '6px 16px',
            fontSize: 13,
            fontWeight: 600,
            color: '#002677',
            background: 'transparent',
            border: '1px solid #002677',
            borderRadius: 4,
            cursor: 'pointer',
          }}
        >
          Logout
        </button>
      </Header.Actions>
    </Header.Container>
  );
};
